/*    
<summary>
  This functional component provides "ChangePasswordPopupHOC" props to the child component.
  1. State "showChangePasswordPopup" that manages the show/hide of pop up
  2. Function "changePasswordToggleHandler" to toggle the show/hide popup state "showChangePasswordPopup"
  Developer:Mohammad Saquib Khan, Created Date:15-September-2025
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";

const ResetPasswordWindowPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showResetPasswordPopup, setShowResetPasswordPopup] =
      useState<boolean>(false);

    const ResetPasswordToggleHandler = () => {
      setShowResetPasswordPopup(!showResetPasswordPopup);
    };

    return (
      <Component
        showResetPasswordPopup={showResetPasswordPopup}
        resetPasswordToggleHandler={ResetPasswordToggleHandler}
        {...props}
      />
    );
  };

export default ResetPasswordWindowPopupHOC;
